import { render } from "./demoTMS.vue?vue&type=template&id=f3908eb4"
import script from "./demoTMS.vue?vue&type=script&lang=js"
export * from "./demoTMS.vue?vue&type=script&lang=js"

import exportComponent from "D:\\bkp\\my-vue-pwa\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__